<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <!--begin::Toolbar-->
    <div class="toolbar" id="kt_toolbar">
      <!--begin::Container-->
      <app-sub-view-header :title="title" :breadcrumbs="breadcrumbs" :back="false"></app-sub-view-header>
      <!--end::Container-->
    </div>
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <!--begin::Container-->
      <div id="kt_content_container" class="container-xxl">
        <!--begin::Layout-->
        <div class="d-flex flex-column flex-lg-row">
          <!--begin::Content-->
          <div class="flex-lg-row-fluid mb-10 mb-lg-0 me-lg-7 me-xl-10">
            <!--begin::Card-->
            <div class="card">
              <!--begin::Card body-->
              <div v-show="isReady" class="card-body p-12">
                <!--begin::Form-->
                <form action="" id="kt_invoice_form">
                  <!--begin::Wrapper-->
                  <div class="d-flex flex-column align-items-start flex-xxl-row">
                    <!--begin::Input group-->
                    <div class="d-flex flex-center flex-equal fw-row text-nowrap order-1 order-xxl-2 me-4" data-bs-toggle="tooltip" data-bs-trigger="hover">
                      <span class="fs-2x fw-bolder text-gray-800"> {{$t('shop.shop_entry')}} # {{  outputStore.numero  }} </span>
                    </div>
                    <div class="d-flex flex-center flex-equal fw-row text-nowrap order-1 order-xxl-2 me-4" data-bs-toggle="tooltip" data-bs-trigger="hover">
                      <span class="fs-2x fw-bolder text-gray-800"> {{$t('shop.date')}}: {{  outputStore.date  }} </span>
                    </div>
                    <div class="d-flex flex-center flex-equal fw-row text-nowrap order-1 order-xxl-2 me-4" data-bs-toggle="tooltip" data-bs-trigger="hover">
                      <span class="fs-2x fw-bolder text-gray-800"> {{$t('shop.entry_from')}}: {{  entryFrom  }} </span>
                    </div>
                  </div>
                  <div class="separator separator-dashed my-10"></div>
                  <div class="mb-0">
                    <div class="table-responsive mb-10">
                      <form @submit.prevent="validateEntryData" class="form">
                        <div class="row">
                          <div class="col-sm-3"><strong>{{ $t('shop.item') }}</strong></div>
                          <div class="col-sm-2"><strong>{{$t('shop.lot_unite')}}</strong></div>
                          <div class="col-sm-1"><strong>{{$t('shop.qty_by_lot')}}</strong></div>
                          <div class="col-sm-1"><strong>{{$t('shop.qty')}}</strong></div>
                          <div class="col-sm-2"><strong>{{$t('shop.conform_quantity')}}</strong></div>
                        </div>
                        <div class="separator separator-dashed"></div>
                        <table class="table g-5 gs-0 mb-0 fw-bolder text-gray-700 table-responsive-sm" data-kt-element="items">
                          <tbody>
                          <tr v-for="(content, key) in formValidateEntryData.productSaleElements" :key="key">
                            <td colspan="6">
                              <div class="row">
                                <div class="col-sm-3">
                                  <input type="text" readonly class="form-control form-control-solid mb-2" v-model="content.name" />
                                </div>
                                <div class="col-sm-2">
                                  <input readonly class="form-control form-control-solid" type="text" :value="content.product_lot_id ? content.product_lot_id : $t('shop.unite')" />
                                </div>
                                <div class="col-sm-1">
                                  <input readonly class="form-control form-control-solid" type="text" :value="content.quantity_lot ? content.quantity_lot : $t('shop.unite')" />
                                </div>
                                <div class="col-sm-1">
                                  <input readonly class="form-control form-control-solid" type="number" v-model="content.product_quantity" />
                                </div>
                                <div class="col-sm-2">
                                  <span data-kt-element="total">
                                    <div class="row fv-row">
                                      <div class="d-flex">
                                        <div class="form-check form-check-custom form-check-solid me-5">
                                          <input class="form-check-input" type="radio" value="yes" v-model="content.status" :name="key.allow" id="allow_guest_reviews_yes" />
                                          <label class="form-check-label" for="allow_guest_reviews_yes">{{$t('shop.yes')}}</label>
                                        </div>
                                        <div class="form-check form-check-custom form-check-solid">
                                          <input class="form-check-input" type="radio" value="no" v-model="content.status" :name="key.allow_guest" id="allow_guest_reviews_no" />
                                          <label class="form-check-label" for="allow_guest_reviews_no">{{$t('shop.no')}}</label>
                                        </div>
                                      </div>
                                    </div>
                                  </span>
                                </div>
                                <div class="col-sm-3" v-if="content.status === 'no'">
                                  <input type="number" :max="content.product_quantity" min="0" class="form-control form-control-solid" v-model="content.received_quantity" :placeholder="$t('shop.enter_quantity')" />
                                </div>
                              </div>
                              <div class="row">
                                <div class="col">
                                  <textarea class="form-control form-control-solid" v-model="content.comments" rows="1" :placeholder="$t('store.ask.placeholder_comment')"></textarea>
                                </div>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                        <div class="modal-footer">

                          <button type="button"  @click="$goBack" class="btn btn-sm btn-light" >{{ $t('button.close') }}</button>
                          <button type="submit" id="kt_submit_create_validate_entry" class="btn btn-sm btn-primary fw-bolder">
                            <span class="indicator-label">{{ $t('button.save') }}</span>
                            <span class="indicator-progress">{{  $t('loading') }}
                             <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <!--end::Wrapper-->
                </form>
                <!--end::Form-->
              </div>
              <div class="card-body p-12 loader" v-show="!isReady">
                <Loader text="Loading..." />
              </div>
            </div>
            <!--end::Card-->
          </div>
          <!--end::Content-->

        </div>
        <!--end::Layout-->
      </div>
      <!--end::Container-->
    </div>

  </div>
</template>


<script>
import AppSubViewHeader from "@/views/Shop/partials/AppSubViewHeader";
import {mapActions, mapGetters} from "vuex";
import Loader from "@/components/Loader.vue";

export default {
  name: "View",
  components: {AppSubViewHeader, Loader},
  data(){
    return {
      breadcrumbs: [
        {
          name: 'Validation de l\'entrée',
          path: '/admin/shops'
        },
      ],

      productSaleElements: {},
      isReady: false,

      formValidateEntryData: {
        id: this.$route.params.id,
        output_id: this.$route.params.output_id,
        productSaleElements : [
          {
            product_sale_element_id :  "",
            product_quantity :  '',
            received_quantity :  null,
            status : ''  ,
            name : ''  ,
            buyPrice: 0,
            sellPrice: 0
          }
        ],
      },
      outputStore: {},
      entryFrom: null
    }
  },

  computed: {
    ...mapGetters('countries',[
      'getCountries'
    ])
  },

  async mounted(){
    this.isReady = false
      let response = await this.showShopOutputProduct({shop_id: this.$route.params.id, output_id: this.$route.params.output_id})
      this.formValidateEntryData.productSaleElements = response?.data?.productSaleElements_collection
      this.outputStore = response?.data?.output_store
      this.entryFrom = response?.data?.from

      $("#editModal").on("shown.bs.modal", function () {
        $('.kt_select2').select2();
      });

      $(".kt_select2").change((e) => {
        switch (e.target.name) {
          case 'country_id':
            this.formEditData.country_id = e.target.value
            break;
        }
      });
      this.isReady = true
  },

  methods: {
    ...mapActions('shop',[
      'showShopOutputProduct',
      'validateShopEntry'
    ]),

    navigateRoute(link){
      this.$router.push({name : link})
    },

    openCreateModal(){
      $('#editModal').modal('toggle')
    },

    async validateEntryData(){
      this.$loading('kt_submit_create_validate_entry')
      let response = {}

      try{
        response = await this.validateShopEntry(this.formValidateEntryData)
        window.toastr['success'](i18n.global.t("notification.shop_validate_entry"))
        this.$router.push({ name: 'shop-moves' })
        this.$stopLoading('kt_submit_create_validate_entry')
        return true
      }catch(err){
        this.$stopLoading('kt_submit_create_validate_entry')
        this.isLoading = false;
      }
    },
  }
}
</script>

<style scoped>

</style>